import { Card, Text } from "react-native-paper";
import type { IconType } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import Button from "../Button";
import { FlatCard } from "../Cards/FlatCard";
import { CircularIconContainer } from "../CircularIconContainer";
import type { CmeAction } from "./types";

export type CmeStatusCardProps = {
	title: string;
	description: string;
	action: CmeAction;
	footnote: string;
	iconName?: IconType;
};

export const CmeStatusCard = ({
	title,
	description,
	action,
	footnote,
	iconName = "certificate-outline",
}: CmeStatusCardProps) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	const content = (
		<Box gap={24} alignItems="center">
			<CircularIconContainer
				iconName={iconName}
				size={62}
				iconSize={24}
				backgroundColor={theme.colors.elevation.level1}
				iconColor={theme.colors.primary}
			/>
			<Box
				gap={4}
				alignItems="center"
				style={isMobile ? undefined : { maxWidth: 560 }}
			>
				<Text variant="titleLarge" style={{ textAlign: "center" }}>
					{title}
				</Text>
				<Text variant="bodyMedium" style={{ textAlign: "center" }}>
					{description}
				</Text>
			</Box>
			<Button mode="contained" icon={action.iconName} onPress={action.onPress}>
				{action.label}
			</Button>
			<Text
				variant="bodySmall"
				style={{
					color: theme.colors.onSurfaceVariant,
					textAlign: "center",
				}}
			>
				{footnote}
			</Text>
		</Box>
	);

	if (isMobile) {
		return content;
	}

	return (
		<FlatCard style={{ borderRadius: theme.roundness * 3 }}>
			<Card.Content style={{ padding: 24 }}>{content}</Card.Content>
		</FlatCard>
	);
};
